import React from 'react';
import { useTranslation } from "react-i18next";
import { Container, Stack, Typography } from "@mui/material";
import { CustomStackFullWidth } from "../styled-components/CustomStyles.style";
import FiveHundred from "../components/errors-svg/FiveHundred";
import SEO from '../components/seo';

const ServerError = () => {
    const { t } = useTranslation();

  
  
  return (
    <>
      <SEO
        title="Server Error"
        description="Internal server error occurred"
      />
      <Container
        maxWidth="lg"
        sx={{
          mt: { md: "9rem" },
          mb: { xs: "72px", md: "0" },
        }}
      >
        <CustomStackFullWidth
          justifyContent="center"
          alignItems="center"
          spacing={4}
        >
          <Stack maxWidth="500px" width="100%" spacing={2} padding="1rem">
            <FiveHundred />
            <Typography align="center" variant="h3">
              {t(
                "Internal server error. Please use registered valid domain and try again."
              )}
            </Typography>
          </Stack>
        </CustomStackFullWidth>
      </Container>
    </>
  );
};

export default ServerError;
